import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { cn } from '@/lib/utils';

export interface SegmentedToggleProps<T extends string> {
  value: T;
  options: readonly T[];
  getLabel: (option: T) => string;
  onChange: (value: T) => void;
  ariaLabel: string;
  className?: string;
}

export function SegmentedToggle<T extends string>({
  value,
  options,
  getLabel,
  onChange,
  ariaLabel,
  className,
}: SegmentedToggleProps<T>) {
  return (
    <ButtonGroup
      aria-label={ariaLabel}
      className={cn(
        '[&_button]:h-auto [&_button]:rounded-sm [&_button]:px-1.5 [&_button]:py-0.5 [&_button]:text-xs [&_button]:font-semibold [&_button]:uppercase [&_button]:tracking-wider',
        className
      )}
    >
      {options.map((option) => {
        const isActive = value === option;

        return (
          <Button
            key={option}
            type="button"
            variant={isActive ? 'secondary' : 'ghost'}
            className={cn(
              !isActive &&
                'text-muted-foreground hover:bg-muted/50 hover:text-muted-foreground'
            )}
            onClick={() => onChange(option)}
            aria-pressed={isActive}
          >
            {getLabel(option)}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
